export default [
	{
		path: "/pros/profile/edit-media",
		exact: true,
		component: "EditProfileMedia/EditProfileMedia",
		mui: true,
	},
];
